import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LettersAvatarComponent } from './letters-avatar.component';



@NgModule({
  declarations: [LettersAvatarComponent],
  imports: [
    CommonModule
  ],
  exports: [LettersAvatarComponent]
})
export class LettersAvatarModule { }
